import { StickerCard } from "@/components/sticker-card/StickerCard.tsx";
import { ApiFormParticipantStatus } from "@/types/forms/form.types.ts";
import { ApiSurveyRespond, ApiSurveyType } from "@/types/survey.types.ts";
import { Button, FullScreenPage, Stack, Title } from "@skailer-com/uikit";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { useEmployeeMe } from "@/queries/employees/use-employees.query.ts";
import { EmployeePageSection } from "@/pages/employees/employee/employee-page.constants.ts";

export const SurveyCompleted = ({ survey }: { survey: ApiSurveyRespond }) => {
  const { t } = useTranslation();
  const { data: employeeMe } = useEmployeeMe();

  const navigate = useNavigate();

  const isCompletedParticipant = survey.participant_status == ApiFormParticipantStatus.completed;
  const isRequest = survey.type === ApiSurveyType.survey_with_approval;

  const getTitle = () => {
    if (!isRequest) return t("surveys:survey_completed_title");
    return isCompletedParticipant
      ? t("surveys:request_submitted_title")
      : t("surveys:request_closed_title");
  };

  const getDescription = () => {
    if (isRequest) {
      return isCompletedParticipant
        ? t("surveys:request_submitted_description")
        : t("surveys:request_closed_description");
    }
    return isCompletedParticipant
      ? t("surveys:survey_completed_description")
      : t("surveys:survey_closed_description");
  };

  return (
    <>
      <FullScreenPage contentSize={"lg"}>
        <Stack direction={"horizontal"} items={"center"}>
          <StickerCard
            title={survey.title}
            caption={survey.description || undefined}
            emoji={survey.emoji || undefined}
          />
          <Stack className={"pl-18"} gap={"lg"}>
            <Title size={"lg"} header={getTitle()} caption={getDescription()}></Title>
            <Stack direction={"horizontal"} gap={"sm"}>
              <Button
                variant={"primary"}
                size={"lg"}
                onClick={() => {
                  navigate("/");
                }}
              >
                {t("common:go_to_home")}
              </Button>
              {isRequest && (
                <Button
                  variant="secondary"
                  size="lg"
                  disabled={!employeeMe}
                  onClick={() => {
                    if (employeeMe) {
                      navigate(
                        `/employees/${employeeMe.id}/${EmployeePageSection.positionRequests}`
                      );
                    }
                  }}
                >
                  {t("approval:my_requests")}
                </Button>
              )}
            </Stack>
          </Stack>
        </Stack>
      </FullScreenPage>
    </>
  );
};
